// extracted by mini-css-extract-plugin
module.exports = {"card":"_3qALWYA8kFNQ5UT35c9HQw","primary":"_27HUxlPWRjPthdALu9sKCb","secondary":"_3CIXmdQw-P8jzWcHk6NAWI"};